<template>
  <div
    class="container"
    :style="{
      background:
        'url(' +
        require('../../assets/img/' + bei_ing) +
        ') no-repeat center center',
      'background-size': '100% 100%',
    }"
  >
    <dingbu @cart-tatus="cartTatus"></dingbu>
    <div class="home_content">
      <div class="bg_color">
        <div class="w">
          <div class="inform__box">
            <div class="box__top">
              <span class="shou__ye">首页</span>
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <span class="ton__zhi">下载专区</span>
            </div>
          </div>
        </div>

        <div class="box-contentgf">
          <router-link
            tag="div"
            class="content-listk"
            v-for="(item, index) in addki"
            :key="index"
            :to="{ path: '/downloadDetail', query: { id: item.id } }"
          >
            <div class="list-one">
              <div class="titles">{{ item.title }}</div>
              <div class="tim">{{ item.createtime }}</div>
            </div>
            <div class="to">{{ item.desc }}</div>
          </router-link>
          <div class="fenye">
            <el-pagination
              background
              layout="prev, pager, next,jumper"
              :total="total"
              :page-size="pageNum"
              @prev-click="prev"
              @next-click="next"
              @current-change="current"
            ></el-pagination>
          </div>
        </div>
        <dibu></dibu>
        <daohan></daohan>
      </div>
    </div>
  </div>
</template>

<script>
import daohan from "../daohan";
import dibu from "../dibu";
import dingbu from "../dingbu";
export default {
  components: {
    daohan,
    dibu,
    dingbu
  },
  data() {
    return {
      bei_ing: this.Public.bei_ing,
      addki: [],
      page: 1,
      pageNum: 10,
      total: 1
    };
  },
  mounted() {
    this.getpolicy()
  },
  methods: {
    cartTatus(val) {
      this.addki = val.info
      this.total = val.total_num
    },

    //分页
    //上一页
    prev() {
      // console.log("eee")
      this.page = this.page - 1
      this.getpolicy()
    },
    //下一页
    next() {
      // console.log("eee")
      this.page = this.page + 1
      this.getpolicy()
    },
    //当前页
    current(e) {
      // console.log(e)
      this.page = e
      this.getpolicy()
    },

    getpolicy() {   //下载专区
      let url = "lists/download", param = {
        page: this.page,
        pageNum: this.pageNum
      };
      this.post(url, param)
        .then((res) => {
          this.addki = res.data.info
          this.total_num = res.data.total_num
          // console.log(res);
        })
        .catch((err) => {
          // console.log(err);
        });
    },
  },
};
</script>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #198bf8 !important;
  color: #fff;
  border-radius: 50%;
}
.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  background-color: #ffffff;
  color: #06121e;
  min-width: 30px;
  border-radius: 2px;
}
</style>
<style scoped>
@import "../../css/policy.css";
</style>